export default function ChartSkeleton() {
  return (
    <div className="mb-4">
      {/* Toggle placeholder */}
      <div className="d-flex justify-content-end mb-2">
        <div className="placeholder-glow">
          <span className="placeholder rounded" style={{ width: "120px", height: "30px", display: "inline-block" }} />
        </div>
      </div>
      {/* Chart area with centered spinner */}
      <div className="rounded bg-light d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
      {/* Description placeholder */}
      <div className="placeholder-glow mt-2">
        <span className="placeholder rounded col-8" style={{ height: "12px" }} />
        <span className="placeholder rounded col-6 mt-1" style={{ height: "12px" }} />
      </div>
    </div>
  );
}
